<div class="request-status" *ngIf="title || displayItems.length > 0">
  <h5 class="request-status--title" *ngIf="title">{{ title }}</h5>
  
  <div class="request-status--container">
    <div 
      *ngFor="let item of displayItems" 
      class="request-status--item"
    >
      <a 
        *ngIf="item.route"
        [routerLink]="getRoutePath(item.route)"
        [queryParams]="getQueryParams(item.route)"
        class="request-status--card"
        [class.request-status--card-approved]="item.status === 'approved'"
        [class.request-status--card-rejected]="item.status === 'rejected'"
        [class.request-status--card-withdrawn]="item.status === 'withdrawn'"
        [class.request-status--card-pending]="item.status === 'pending'"
      >
        <div class="request-status--icon-wrapper">
          <div class="request-status--icon" [attr.data-status]="item.status">
            <img [src]="getStatusIconUrl(item.status)" alt="" />
          </div>
        </div>
        
        <div class="request-status--content">
          <div class="request-status--label">{{ item.label }}</div>
          <div class="request-status--count">{{ item.count }}</div>
          <div class="request-status--link">REQUESTS</div>
        </div>
      </a>
      <a 
        *ngIf="item.href && !item.route"
        [href]="item.href"
        class="request-status--card"
        [class.request-status--card-approved]="item.status === 'approved'"
        [class.request-status--card-rejected]="item.status === 'rejected'"
        [class.request-status--card-withdrawn]="item.status === 'withdrawn'"
        [class.request-status--card-pending]="item.status === 'pending'"
      >
        <div class="request-status--icon-wrapper">
          <div class="request-status--icon" [attr.data-status]="item.status">
            <img [src]="getStatusIconUrl(item.status)" alt="" />
          </div>
        </div>
        
        <div class="request-status--content">
          <div class="request-status--label">{{ item.label }}</div>
          <div class="request-status--count">{{ item.count }}</div>
          <div class="request-status--link">REQUESTS</div>
        </div>
      </a>
    </div>
  </div>
</div>

